import { LoadState } from "../../constants/enums";
import { ILead, ILeadFollowUp } from "../../models";

export interface ILeadListState {
    list: ILead[];
    loading: LoadState;
    lead: ILead;
    leadLoading: LoadState;
    error: string | null;
}

export interface ILeadFollowUpListState {
    list: ILeadFollowUp[];
    totalRecords: number;
    loading: LoadState;
    followUp: ILeadFollowUp;
    followUpLoading: LoadState;
    error: string | null;
}

export interface ILeadsState {
    leads: ILeadListState;
    followUps: ILeadFollowUpListState;
}

export const initialLeadFollowUp: ILeadFollowUp = {
    followup_id: 0,
    followup_code: null,
    lead_id: 0,
    customer_id: null,
    customer_policy_id: null,
    customer_name: null,
    line_of_business: null,
    note: null,
    opportunity_amount: null,
    email: null,
    phone: null,
    followup_type: null,
    followup_date: null,
    reason: null,
    next_followup_date: null,
    next_followup_reason: null,
    followup_status: "OPEN",
    type: "Contact",
    due_date: null,
    assigned_to_id: null,
    assigned_to_name: null,
    status: "ACTIVE",
    created_by_id: null,
    created_by_name: null,
    modified_by_id: null,
    modified_by_name: null,
    link_url: null,
};

export const initialLead: ILead = {
    id: null,
    lead_id: null,
    insurance_type: null,
    insurance_sub_type: null,
    first_name: "",
    last_name: "",
    assigned_to_id: null,
    assigned_to_name: null,
    business_name: "",
    group_name: "",
    email: "",
    phone: "",
    notes: "",
    comment: "",
    date: null,
    time_to_contact: "",
    insert_ts: "",
    status: "ACTIVE",
    producer_name: null,
    isconvert_status: "Leads",
    lead_source: "",
    specify: "",
    producer_id: "",
    followup_type: null,
    followup_date: null,
    followup_reason: null,
};

export const initialLeadState: ILeadsState = {
    leads: {
        list: [],
        loading: LoadState.NotLoaded,
        lead: initialLead,
        leadLoading: LoadState.NotLoaded,
        error: null,
    },
    followUps: {
        list: [],
        totalRecords: 0,
        loading: LoadState.NotLoaded,
        followUp: initialLeadFollowUp,
        followUpLoading: LoadState.NotLoaded,
        error: null,
    },
};
